//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueFilePond from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileEncode, FilePondPluginFileMetadata, FilePondPluginFileValidateSize);
export default {
  name: 'InputField',
  components: {
    FilePond,
  },
  props: {
    label: String,
    name: String,
    multiple: Boolean,
    value: '',
    error: '',
  },
  methods: {
    handleFilePondInit: function(value){
      this.$emit('input', value);
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/FileField.vue